export class Resume {
    public resumename: string = '';
}